// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3LpGF","Success":"Button_Success__VkksS","Danger":"Button_Danger__1rrOP"};